export enum NavViewOptionName {
  AddView = 'Add View',
  AddFolder = 'Add Folder',
  Edit = 'Edit',
  Copy = 'Copy',
  Delete = 'Delete',
  Rename = 'Rename',
  Favorite = 'Favorite',
  Unfavorite = 'Unfavorite'
}
